export const API_ENDPOINT = {
  Profile: {
    api: "/admin-api/v1/profile",
    method: "GET",
  },
  Login: {
    api: "/auth/v1/login",
    method:'POST',
   // magicToken:"/auth/v1/magic-token",
    //tokenVerify:"/auth/v1/magic-token/verify"
  },
  Otp: {
    api: "/auth/v1/verifyOTP",
    method:'POST'
  },
  Vendor: {
    api: "/admin-api/v1/vendors",
    user: "/admin-api/v1/vendors/users",
    method: "GET",
  },
  SubVendor: {
    api: "/admin-api/v1/sub-vendors",
    method: "GET",
    moreApi:"/admin-api/v1/sub-vendors/more-details"
  },
  Compliance: {
    api: "/admin-api/v1/compliance-submissions",
    method: "GET",
    complianceRegex: "/admin-api/v1/compliance-validations"
  },
  ReUploadCompliance: {
    api: "/admin-api/v3/compliance-resubmit",
    method: "POST",
  },
  ConfigCompliance: {
    api:"/admin-api/v1/compliances",
    verificationApi:'/admin-api/v1/compliance-verifications'
  },
  OnBoardCompliance: {
    api: "/admin-api/v3/onboard-compliances",
    method: "GET",
  },
  Driver:{
    api:"/admin-api/v1/drivers",
    matrixApi:"/admin-api/v1/drivers/matrix",
    ticketApi:"/admin-api/v1/drivers/tickets",
    moreApi:"/admin-api/v1/drivers/more-details"
  },
  Faq:{
    api:"/admin-api/v1/faqs",
    sectionApi:"/admin-api/v1/faq-sections",
    subSectionApi: "/admin-api/v1/faq-sub-sections"
  },

  Car:{
    api:"/admin-api/v1/config-cars",
    facilitiesApi:"/trip-api/v1/get-facilities"
  },
  Tag:{
    api:"/admin-api/v1/tags"
  },
  Rating:{
    api:"/admin-api/v1/ratings"
  },
  Customer:{
    api:"/admin-api/v1/customers",
    matrixApi:"/admin-api/v1/customers/matrix",
    ticketApi:"/admin-api/v1//customers/tickets",
  },
  CustomerComplaints:{
    api:"/trip-api/v2/complains",
    apiById:"/trip-api/v2/complain",
    updateComplainApi: "/trip-api/v2/updateComplain",
  },
  Dashboard:{
    registrationApi:"/admin-api/v1/total-rides",
    rideDetailsApi:"/admin-api/v1/ride-details",
    rideAnalyticApi:"/admin-api/v1/daily-ride-analytics",
    ourCustomerApi:"/admin-api/v1/our-daily-customers",
    ourCarApi: "/admin-api/v1/our-cars",
    cabRideApi: "/admin-api/v1/get-cab-ride-details",
    topVendorApi: "/admin-api/v1/get-top-vendor",
    topSubVendorApi: "/admin-api/v1/get-top-sub-vendor",
    topDriverApi: "/admin-api/v1/get-top-drivers",
    rideAcceptApi: "/admin-api/v1/ride-acceptance",
    dashboardFeedbackApi: "/admin-api/v1/get-feedback",
  },
  Vehicle:{
    api:"/admin-api/v1/company-vehicles",
    matrixApi:"/admin-api/v1/vehicle-matrix",
    moreApi:"/admin-api/v1/compliance-submission-values",
    driverApi: "/admin-api/v1/driver-vehicles",
  },
  Registration:{
    api:"/auth/v1/register",
  },
  Trip:{
    api:"/trip-api/v1/trips",
    apiV3: "/trip-api/v3/",
    sosApi:"/trip-api/v1/emergencyAlerts",
    cancelApi:"/trip-api/v1/cancel-trips",
    assignDriverApi:"/admin-api/v1/driver-assigns",
    invoiceApi:"/trip-api/v2/invoices",
    invoiceDownloadApi:"/trip-api/v1/download-invoices",
    shareTripApi :"/trip-api/v1/share-trips"  //migrated sharetripapi
  },
  Notification:{
    api:"/admin-api/v1/notification",
    countApi:"/admin-api/v1/notification/count",
    seenApi:"/admin-api/v1/notification/seen"
  },
  AssignVehicle:{
    requestVehicleApi:"/admin-api/v1/vehicle-list",
    listAssignedVehicleApi:"/admin-api/v1/assigned-vehicle-list",
    assignVehicleApi:"/admin-api/v1/assign-vehicle",
    assignDriverApi:'/admin-api/v1/assign-driver',
    assignSubVendorApi:'/admin-api/v1/assign-subvendor',

  },
  ChooseYourService:{
    api:"/trip-api/v1/trip-services",
  },
  RateCard:{
   api:"/admin-api/v1/rate-cards",
   baseFuelApi:"/admin-api/v1/base-fuel-rates"
  },

  ServiceCity:{
    api:"/trip-api/v1/service-cities",
    serviceRegion:"/trip-api/v1/service-regions",
    subVendorRegion:"/admin-api/v1/subvendor-serviceable-regions"
  },
  Logout:{
    api:"/auth/v1/logout"
  },
  Report:{
    bookingApi:"/admin-api/v1/booking-status",
    customerMatrixApi:"/admin-api/v1/customer-matrix",
    revenueMatrixApi:"/admin-api/v1/revenue-matrix",
    bookingMatrixApi:"/admin-api/v1/booking-matrix",
    revenueApi:"/admin-api/v1/revenue-reports",
    revenueExportApi:"/admin-api/v1/",
    bookingExportApi:"/trip-api/v1/trip-export",
    couponReportApi:"/admin-api/v2/reports/coupon",
    tripDetailsReportAPI: "/admin-api/v3/reports/trip",
    tripBookingReportAPI: "/admin-api/v3/reports/trip-booking"
  },
  GeneratedReport:{
    generatedReportApi: "/admin-api/v3/tasks/report"
  },
  MapApi:{
    api:"https://maps.googleapis.com/maps/api/"
  },
  rolesAndPermissions: {
    supplierRolesApi: "/admin-api/v1/supplier-roles",
    rolesAndPermissionsApi: "/admin-api/v1/role-permissions"
  },

  couponApi:{
    getApi:"/admin-api/v1/coupons",
    addCoupon:"/admin-api/v1/coupons",
    update:"/admin-api/v1/coupons",
    status: '/admin-api/v1/coupons/status',
    delete:"/admin-api/v1/coupons",
  },
  liveTrips:{
    api:"/livetrip-api/v1/trip"
  },
  operations: {
    allotApi: "/admin-api/v1/assign-driver",
    availableVehicleApi: "/admin-api/v1/driver-assigns",
    availableSuppliersApi: "/admin-api/v1/sub-vendor-driver-assigns",
  },

  //googleMap endpoints
   GoogleMap:{
    autocompleteApi:"/trip-api/v1/auto-complete",
    nearbysearch:"/trip-api/v1/nearbySearch-api",
    placeApi:"/trip-api/v1/place-api",
    directionApi:"/trip-api/v1/direction-api",
    geocodeApi:"/geocode/json",
    locationCheck:'/trip-api/v1/location-check'
  },

   CustomerTrip:{
    rateCalculationApi:"/trip-api/v2/rate-estimates",
    rateCalculationRentalApi:"/trip-api/v2/rate-estimates",
    tripCheckoutApi:"/trip-api/v2/book-trip",
    tripSlabApi:"/trip-api/v1/start-details",
    cancelTripApi:"/trip-api/v1/dummy-cancel-trips",
    cancelReasonApi:"/trip-api/v1/cancel-reasons",
    refundPriceApi:"/trip-api/v1/refund-prices",
    tripRentalApi:"/trip-api/v2/book-trip",
    rentalSlabApi:"/trip-api/v1/start-details"
  },

  CountryList: {
    api: "/auth/v1/getCountryList"
  },
  AccountDeletion: {
    requestApi: "/auth/v1/request-account-deletion",
    verifyApi: "/auth/v1/verify-account-deletion",
  },
}